// The two width thresholds the chrome changes shape at, in one place, so the
// CSS media queries in AppShell.css and the components that must agree with
// them (the destinations menu, the inspector sheet) cannot drift apart.
//
// MENU_MAX_WIDTH: at 1023 and below the rail and the context list are gone
// and the top bar's menu button is the only way to a destination.
// SHEET_MAX_WIDTH: at 767 and below the inspector is a full-width sheet.
import { useEffect, useState } from 'react';

export const MENU_MAX_WIDTH = 1023;
export const SHEET_MAX_WIDTH = 767;

// The runner jsdom ships here has no matchMedia, and a chrome component that
// asks a width question must not throw where the answer is simply "not
// narrow": the status bar took the whole footer down with it in three tests.
function matches(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
}

export function useNarrow(maxWidth: number): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [narrow, setNarrow] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(query);
    const onChange = (): void => setNarrow(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);
  return narrow;
}
